function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { Autocomplete as NativeAutocomplete } from "../_/@ui-kitten/components";
import wrapComponent from "../core/wrapComponent";
import { STYLE_WRAPPER_TYPE } from "../utils/constants";
import { useForwardRef } from "../hooks";
import React from 'react';

function AutocompleteElement(props, ref) {
  const rest = _extends({}, props);

  const autocompleteRef = useForwardRef(ref);
  React.useEffect(() => {
    var _autocompleteRef$curr, _autocompleteRef$curr2;

    const shouldBecomeVisible = (((_autocompleteRef$curr = autocompleteRef.current) === null || _autocompleteRef$curr === void 0 ? void 0 : _autocompleteRef$curr.isFocused()) || false) && props.children;

    if (((_autocompleteRef$curr2 = autocompleteRef.current) === null || _autocompleteRef$curr2 === void 0 ? void 0 : _autocompleteRef$curr2.state.listVisible) !== shouldBecomeVisible) {
      var _autocompleteRef$curr3;

      (_autocompleteRef$curr3 = autocompleteRef.current) === null || _autocompleteRef$curr3 === void 0 ? void 0 : _autocompleteRef$curr3.setState({
        listVisible: shouldBecomeVisible
      });
    }
  }, [props.children]);
  return /*#__PURE__*/React.createElement(NativeAutocomplete, _extends({
    ref: autocompleteRef
  }, rest));
}

export default wrapComponent(AutocompleteElement, {
  styleWrapper: STYLE_WRAPPER_TYPE.relativeSize,
  isForwardRef: true
});